import { Clock, CheckCircle, AlertTriangle, Activity, FileText, Target } from "lucide-react";

// Project status display mapping
export const statusDisplayMap = {
  'draft': 'Draft',
  'confirmed': 'Confirmed', 
  'in_progress': 'In Progress',
  'delivered': 'Ended'
} as const;

// Project status colors for badges
export const statusColors = {
  "draft": "bg-gray-100 text-gray-800",
  "confirmed": "bg-green-100 text-green-800",
  "in_progress": "bg-blue-100 text-blue-800",
  "delivered": "bg-purple-100 text-purple-800"
} as const;

// Project type icons
export const typeIcons = {
  "adhoc": "📦",
  "subscription": "🔁"
} as const;

// Project type display mapping
export const typeDisplayMap = {
  "adhoc": "Ad Hoc",
  "subscription": "Subscription"
} as const;

// Get status icon component based on status
export const getStatusIcon = (status: string) => {
  switch (status) {
    case "draft": return FileText;
    case "confirmed": return CheckCircle;
    case "in_progress": return Clock;
    case "delivered": return Target;
    default: return Clock;
  }
};

// Type definitions for better TypeScript support
export type ProjectStatus = keyof typeof statusDisplayMap;
export type ProjectType = keyof typeof typeIcons;